import { forwardRef, type HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { AnimatePresence } from 'framer-motion';

import { type LotteryTicketType } from '@/common/types/lottery';
import { TicketIcon } from '@/components/ui/TicketIcon/TicketIcon';
import { selectMyTicketsByType } from '@/redux/selectors/lotterySelector';
import { useAppSelector } from '@/redux/store';

import { ActiveEffect } from './ActiveEffect';

import css from './styles.module.scss';

interface LotteryNavItemProps extends HTMLAttributes<HTMLButtonElement> {
  label: string;
  ticketType: LotteryTicketType;
  isActive?: boolean;
}

const LotteryNavItem = forwardRef<HTMLButtonElement, LotteryNavItemProps>(
  ({ label, ticketType, isActive, ...props }, ref) => {
    const { t } = useTranslation();
    const tickets = useAppSelector((state) =>
      selectMyTicketsByType(state, ticketType),
    );

    const count = tickets?.length;

    return (
      <button
        ref={ref}
        {...props}
        className={cn(props.className, css.lotteryNavItem)}
      >
        <AnimatePresence>
          {isActive && <ActiveEffect type={ticketType} />}
        </AnimatePresence>
        <TicketIcon type={ticketType} className="size-[40px] shrink-0" />
        <div className="flex flex-col gap-[4px]">
          <span className="text-[10px] font-medium text-white/40 leading-none">
            {t(label)}
          </span>
          <span className="text-[24px] font-extrabold leading-none">
            {count || 0}
          </span>
        </div>
      </button>
    );
  },
);

export { LotteryNavItem };
